<div class="skel-grid">
  @for (cell of cells; track cell) {
    <div class="skel-tile"></div>
  }
</div>
